import {
  SET_AUTH_STATUS,
  SET_USERNAME,
  SET_PAYMENT_PLAN_TYPE,
  SET_SUBSCRIPTION_METHOD,
  SET_LANDING_SCROLL_POSITION,
  SET_GIFT_FORM_STATUS,
  SET_USER_DATA,
  SET_CREDIT_CARD_DATA,
  SET_SCHEDULE_DATA,
  SET_EXERCISES_DATA,
} from './actions';

const DEFAULT_STATE = {
  slides: ['greeting', 'about', 'features', 'mobile-app', 'subscription-plans', 'book'],
  landingScrollPosition: 'greeting',
  session: {
    authenticated: !!localStorage.getItem('token') || false,
    userName: localStorage.getItem('userName') || '',
  },
  registration: {
    subscription_method: '',
    showGiftForm: false,
  },
  user: {
    id: null,
    first_name: '',
    last_name: '',
    email: '',
    subscribed: null,
    subscribed_on_push_notifications: null,
    is_gift: null,
    current_week: null,
    payment_plan_type: 'yearly',
    subscription_method: '',
    payment_status: '',
    time_zone: '',
  },
  card: {
    last4: '',
    month: '',
    year: '',
    address_zip: '',
  },
  schedule: {
    day_of_week: null,
    day_of_week_to_review: null,
    number_per_week: null,
  },
  exercises: [],
};

const rootReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_AUTH_STATUS:
      return { ...state, session: { ...state.session, authenticated: action.payload } };
    case SET_USERNAME:
      return { ...state, session: { ...state.session, userName: action.payload } };
    case SET_PAYMENT_PLAN_TYPE:
      return { ...state, user: { ...state.user, payment_plan_type: action.payload } };
    case SET_SUBSCRIPTION_METHOD:
      return { ...state, registration: { ...state.registration, subscription_method: action.payload } };
    case SET_GIFT_FORM_STATUS:
      return { ...state, registration: { ...state.registration, showGiftForm: action.payload } };
    case SET_LANDING_SCROLL_POSITION:
      return { ...state, landingScrollPosition: action.payload };
    case SET_USER_DATA:
      return { ...state, user: action.payload };
    case SET_CREDIT_CARD_DATA: {
      return { ...state, card: action.payload };
    }
    case SET_SCHEDULE_DATA:
      return { ...state, schedule: action.payload };
    case SET_EXERCISES_DATA:
      return { ...state, exercises: action.payload };
    default:
      return state;
  }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers.js